import { B2BNavigationVisibilityPolicy } from '@react-native-common/common'

import type { NavigationData } from '../navigationModel'
import { buildB2BNavigationItems } from './buildNavigationItems'
import {
  getProfileAvatarUrl,
  getProfileEmail,
  getProfileUsername,
} from './constants'
import { BASE_B2B_NAVIGATION_MODEL } from './navigationModel'
import type { BuildB2BNavigationModelOptions, NavigationItem } from './types'

export const buildB2BNavigationModel = ({
  userState,
  profileAgentWarningMessage,
  visibleContext,
  isWebView,
  unreadTotal,
}: BuildB2BNavigationModelOptions): NavigationData => {
  const avatarUrl = getProfileAvatarUrl(userState)
  const username = getProfileUsername(userState)
  const email = getProfileEmail(userState)
  const { isActAs } = visibleContext
  const visibleByType: Partial<Record<NavigationItem['type'], boolean>> =
    B2BNavigationVisibilityPolicy.getVisibleByType(visibleContext)

  return {
    ...BASE_B2B_NAVIGATION_MODEL,
    profile: {
      ...BASE_B2B_NAVIGATION_MODEL.profile,
      avatarUrl,
      username,
      email,
      actingAsLabel: BASE_B2B_NAVIGATION_MODEL.profile?.actingAsLabel,
      isActAs,
      agentWarningMessage: profileAgentWarningMessage,
    },
    items: buildB2BNavigationItems({
      items: BASE_B2B_NAVIGATION_MODEL.items as NavigationItem[],
      visibleByType,
      visibleContext,
      isActAs,
      isWebView,
      unreadTotal,
    }),
  }
}
